import axios from "axios";
import {
  LOGIN_SUCCESS,
  APPROVED_SUPPLIERS,
  UNAPPROVED_SUPPLIERS,
  FETCH_ADMIN_STATS,
  APPROVED_CUSTOMERS,
  FETCH_PRODUCTS,
  UNAPPROVED_CUSTOMERS,
  BASE_CURRENCY,
  ADD_CURRENCY,
  ADD_CATEGORY,
  FETCH_COUNTRIES,
  FETCH_CURRENCIES,
  FETCH_CATEGORIES,
  ADD_PRODUCT,
  FETCH_APPROVED_SUPPLIER,
  FETCH_UNAPPROVED_SUPPLIER,
  FETCH_SETTINGS,
  DELETE_APPROVED_SUPPLIER,
  GET_CUSTOMER,
  GET_UNAPPROVED_CUSTOMER,
  DELETE_APPROVED_CUSTOMER,
  PAUSE_SUPPLIER_SIGNUP,
  RESUME_SUPPLIER_SIGNUP,
  PAUSE_USER_SIGNUP,
  RESUME_USER_SIGNUP,
  LOGOUT,
  ADD_SUPPLIER,
  ADD_CUSTOMER,
  TOKEN,
  UPDATE_CUSTOMER_LICENCE,
  UPDATE_CUSTOMER,
  UPDATE_UNAPPROVED_CUSTOMER,
  UPDATE_SUPPLIER,
  UPDATE_UNAPPROVED_SUPPLIER,
  UPDATE_SUPPLIER_LICENCE,
  UPDATE_PRODUCT,
  UPDATE_ADMIN_USERNAME,
  DELETE_PRODUCT,
  DELETE_UNAPPROVED_SUPPLIER,
  DELETE_UNAPPROVED_CUSTOMER,
  FETCH_ORDERS,
  FETCH_ORDERS_BY_SUPPLIER,
  FETCH_ORDER,
  FETCH_TRANSACTIONS,
  FETCH_SELECTED_SUPPLIERS,
  PAUSE_SUPPLIER_CALL_REQUEST,
  RESUME_SUPPLIER_CALL_REQUEST,
  PAUSE_CUSTOMER_CALL_REQUEST,
  RESUME_CUSTOMER_CALL_REQUEST,
  CALL_USER_REQUESTS,
  CALL_SUPPLIER_REQUESTS,
  FETCH_SUPPLIER_FAQ,
  FETCH_CUSTOMER_FAQ,
  CREATE_SUPPLIER_FAQ,
  CREATE_USER_FAQ,
  DELETE_SUPPLIER_FAQ,
  DELETE_USER_FAQ,
  DELETE_CALL_USER_REQUEST,
  DELETE_CALL_SUPPLIER_REQUEST,
  UPDATE_MULTIPLE_CUSTOMERS,
  UPDATE_MULTIPLE_APPROVED_SUPPLIERS,
  FETCH_SUPPLIER_PAYMENTS,
  FETCH_SUPPLIER_PRODUCTS,
  FETCH_SUPPLIER_REPORTS,
  UPDATE_SUPPLIER_PAYMENTS,
  REFUND,
  RESET_EMAIL,
  RESET_CODE,
  RESTORE_ACCOUNT,
  RESTORE_SUPPLIER_ACCOUNT,
  RESTORE_USER_ACCOUNT,
  DELETED_SUPPLIERS,
  DELETED_USERS,
} from "./types";
import { toast } from "react-toastify";
import download from "downloadjs";

export const adminLogin = (data, navigator, setCookie) => (dispatch) => {
  axios
    .post(`${process.env.REACT_APP_ADMIN_BASE_URL}/login`, data)
    .then((res) => {
      console.log(res);
      setCookie("token", res.data?.token, { path: "/", maxAge: 7200 });
      setCookie("currentAdmin", res.data?.data, { path: "/", maxAge: 7200 });

      // localStorage.setItem('token', res.data
      //     ?.token);

      dispatch({
        type: LOGIN_SUCCESS,
        payload: res.data?.data,
      });

      dispatch({
        type: TOKEN,
        payload: res.data?.token,
      });

      toast.success("Login successful!");
      navigator("/");
    })
    .catch((err) => {
      toast.error(err.response?.data?.message);
    });
};

export const forgot_password = (data, navigator, done) => (dispatch) => {
  axios
    .post(`${process.env.REACT_APP_ADMIN_BASE_URL}/forgot-password`, data)
    .then((response) => {
      dispatch({
        type: RESET_EMAIL,
        payload: data.email,
      });

      toast.success(response?.data?.message);
      done();
      navigator("/verify-token");
    })
    .catch((err) => {
      done();
      toast.error(err.response?.data?.message);
    });
};

export const verify_token = (data, navigator, done) => (dispatch) => {
  axios
    .post(`${process.env.REACT_APP_ADMIN_BASE_URL}/verify-email-token`, data)
    .then((response) => {
      dispatch({
        type: RESET_CODE,
        payload: data.token,
      });

      done();
      navigator("/reset-password");
    })
    .catch((err) => {
      done();
      toast.error(err.response?.data?.message[0]);
    });
};

export const reset_password = (data, navigator, done) => (dispatch) => {
  axios
    .post(`${process.env.REACT_APP_ADMIN_BASE_URL}/reset-password/1`, data)
    .then((response) => {
      toast.success(response?.data?.message);
      done();
      setTimeout(() => {
        navigator("/login");
      }, 2000);
    })
    .catch((err) => {
      done();
      toast.error(err.response?.data?.message[0]);
    });
};

export const sync_login = (token, currentAdmin) => (dispatch) => {
  dispatch({ type: LOGIN_SUCCESS, payload: currentAdmin });

  dispatch({ type: TOKEN, payload: token });
};

export const logout = (navigator) => (dispatch) => {
  dispatch({ type: LOGOUT });
  toast.success("Logout successful!");
  navigator("/login");
};

export const fetch_stats =
  (token, success, filter = "") =>
  (dispatch) => {
    let query = filter !== "" ? "?filter=" + filter : "";
    axios
      .get(`${process.env.REACT_APP_ADMIN_BASE_URL}/dashboard${query}`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        success();
        dispatch({
          type: FETCH_ADMIN_STATS,
          payload: res.data?.data,
        });
      })
      .catch((err) => {
        if (err.response) {
          if (err.response.status == 401) {
            window.location.href = "/login";
          }
          // console.log(err.response.status);
        }
      });
  };

export const fetch_approved_suppliers =
  ({ token, success, params }) =>
  (dispatch) => {
    let p = { page: 1 };
    let mparams = new URLSearchParams({ ...p, ...params }).toString();
    axios
      .get(
        `${process.env.REACT_APP_ADMIN_BASE_URL}/get-approved-suppliers?${mparams}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        success();
        dispatch({
          type: APPROVED_SUPPLIERS,
          payload: res.data?.data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const search_approved_suppliers =
  (token, type, value, success) => (dispatch) => {
    axios
      .get(
        `${process.env.REACT_APP_ADMIN_BASE_URL}/get-approved-suppliers?type=${type}&value=${value}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        success();
        dispatch({
          type: APPROVED_SUPPLIERS,
          payload: res.data?.data,
        });
      })
      .catch((err) => {
        success();
        console.log(err);
      });
  };

export const update_selected_suppliers = (token, id, success) => (dispatch) => {
  dispatch({ type: FETCH_SELECTED_SUPPLIERS, payload: [] });
  axios
    .post(
      `${process.env.REACT_APP_ADMIN_BASE_URL}/update-selected-suppliers/${id}`,
      null,
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    )
    .then((res) => {
      success();
      dispatch({ type: FETCH_SELECTED_SUPPLIERS, payload: res.data.data });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const fetch_unapproved_suppliers =
  (token, success, filter, page) => (dispatch) => {
    let fltr = filter !== undefined ? "&filter=" + filter : "";
    let mpage = page !== undefined ? page : 1;
    axios
      .get(
        `${process.env.REACT_APP_ADMIN_BASE_URL}/get-unapproved-suppliers?page=${mpage}${fltr}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        success();
        dispatch({
          type: UNAPPROVED_SUPPLIERS,
          payload: res.data?.data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const fetch_deleted_suppliers =
  (token, success, filter, page) => (dispatch) => {
    let fltr = filter !== undefined ? "&filter=" + filter : "";
    let mpage = page !== undefined ? page : 1;
    axios
      .get(
        `${process.env.REACT_APP_ADMIN_BASE_URL}/get-deleted-suppliers?page=${mpage}${fltr}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        success();
        dispatch({
          type: DELETED_SUPPLIERS,
          payload: res.data?.data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const fetch_deleted_customers =
  (token, success, filter, page) => (dispatch) => {
    let fltr = filter !== undefined ? "&filter=" + filter : "";
    let mpage = page !== undefined ? page : 1;
    axios
      .get(
        `${process.env.REACT_APP_ADMIN_BASE_URL}/get-deleted-customers?page=${mpage}${fltr}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        success();
        dispatch({
          type: DELETED_USERS,
          payload: res.data?.data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const search_unapproved_suppliers =
  (token, type, value, success) => (dispatch) => {
    axios
      .get(
        `${process.env.REACT_APP_ADMIN_BASE_URL}/get-unapproved-suppliers?type=${type}&value=${value}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        success();
        dispatch({
          type: UNAPPROVED_SUPPLIERS,
          payload: res.data?.data,
        });
      })
      .catch((err) => {
        success();
        console.log(err);
      });
  };

export const fetch_approved_customers =
  ({ token, success, filter, params, page = 1 }) =>
  (dispatch) => {
    let fltr = filter !== undefined ? "&filter=" + filter : "";
    let p = { page: 1 };
    let mparams = new URLSearchParams({ ...p, ...params }).toString();
    axios
      .get(
        `${process.env.REACT_APP_ADMIN_BASE_URL}/get-approved-customers?${mparams}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        success();
        dispatch({
          type: APPROVED_CUSTOMERS,
          payload: res.data?.data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const search_approved_customers =
  (token, type, value, success) => (dispatch) => {
    axios
      .get(
        `${process.env.REACT_APP_ADMIN_BASE_URL}/get-approved-customers?type=${type}&value=${value}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        // console.log(res.data?.data);
        success();
        dispatch({
          type: APPROVED_CUSTOMERS,
          payload: res.data?.data,
        });
      })
      .catch((err) => {
        success();
        console.log(err);
      });
  };

export const fetch_unapproved_customers =
  ({ token, success, filter, page = 1 }) =>
  (dispatch) => {
    let fltr = filter !== undefined ? "&filter=" + filter : "";
    axios
      .get(
        `${process.env.REACT_APP_ADMIN_BASE_URL}/get-unapproved-customers?page=${page}${fltr}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        success();
        dispatch({
          type: UNAPPROVED_CUSTOMERS,
          payload: res.data?.data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const search_unapproved_customers =
  (token, type, value, success) => (dispatch) => {
    axios
      .get(
        `${process.env.REACT_APP_ADMIN_BASE_URL}/get-unapproved-customers?type=${type}&value=${value}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        success();
        console.log(res);
        dispatch({
          type: UNAPPROVED_CUSTOMERS,
          payload: res.data?.data,
        });
      })
      .catch((err) => {
        success();
        console.log(err);
      });
  };

export const fetch_products =
  ({ token, params, success }) =>
  (dispatch) => {
    let p = { page: 1 };
    let mparams = new URLSearchParams({ ...p, ...params }).toString();
    console.log(mparams);
    axios
      .get(`${process.env.REACT_APP_ADMIN_BASE_URL}/get-products?${mparams}`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        success();
        dispatch({
          type: FETCH_PRODUCTS,
          payload: res.data?.data,
        });
      })
      .catch((err) => {
        success();
        console.log(err);
      });
  };

export const update_site_details = (data, token, success) => (dispatch) => {
  axios
    .post(`${process.env.REACT_APP_ADMIN_BASE_URL}/update-site-details`, data, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then((res) => {
      console.log(res);
      toast.success(res.data?.message);
      if (success) success();
    })
    .catch((err) => {
      console.log(err);
      if (success) success();
    });
};

export const update_operations = (data, token, success) => (dispatch) => {
  axios
    .post(`${process.env.REACT_APP_ADMIN_BASE_URL}/update-operations`, data, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then((res) => {
      console.log(res);
      toast.success(res.data?.message);
      if (success) success();
    })
    .catch((err) => {
      console.log(err);
      if (success) success();
    });
};

export const update_platform_fees = (data, token, success) => (dispatch) => {
  axios
    .post(`${process.env.REACT_APP_ADMIN_BASE_URL}/update-fees`, data, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then((res) => {
      console.log(res);
      toast.success(res.data?.message);
      if (success) success();
    })
    .catch((err) => {
      console.log(err);
      if (success) success();
    });
};

export const get_base_currency = (token, success) => (dispatch) => {
  axios
    .get(`${process.env.REACT_APP_ADMIN_BASE_URL}/get-base-currency`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then((res) => {
      if (success) {
        success();
      }
      dispatch({
        type: BASE_CURRENCY,
        payload: res.data?.data,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const get_currencies = (token) => (dispatch) => {
  axios
    .get(`${process.env.REACT_APP_ADMIN_BASE_URL}/get-currencies`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then((res) => {
      dispatch({
        type: FETCH_CURRENCIES,
        payload: res.data?.data,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const get_countries = (token) => (dispatch) => {
  axios
    .get(`${process.env.REACT_APP_ADMIN_BASE_URL}/get-countries`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then((res) => {
      console.log(res);
      dispatch({
        type: FETCH_COUNTRIES,
        payload: res.data?.data,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const add_currency = (data, success, token) => (dispatch) => {
  axios
    .post(`${process.env.REACT_APP_ADMIN_BASE_URL}/add-currency`, data, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then((res) => {
      console.log(res);
      toast.success(res.data?.message);
      dispatch({ type: ADD_CURRENCY, payload: data });
      success();
    })
    .catch((err) => {
      console.log(err);
    });
};

export const edit_currency = (data, updatedCurrency, token, success) => (dispatch) => {
  axios
    .post(`${process.env.REACT_APP_ADMIN_BASE_URL}/edit-currency`, data, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then((res) => {
      toast.success(res.data?.message);
      // dispatch({ type: ADD_CURRENCY, payload: updatedCurrency });
      success();
    })
    .catch((err) => {
      console.log(err);
    });
};

export const create_product = (data, token, status, success) => (dispatch) => {
  axios
    .post(
      `${process.env.REACT_APP_ADMIN_BASE_URL}/create-product/${status}`,
      data,
      {
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then((res) => {
      console.log(res);
      toast.success(res.data?.message);
      dispatch({
        type: ADD_PRODUCT,
        payload: res.data?.data,
      });
      success();
    })
    .catch((err) => {
      const errorData = err.response?.data?.message;
      if (Array.isArray(errorData)) {
        toast.error(errorData[0]);
      } else {
        toast.error(errorData || "An error occurred");
      }
    });
};

export const update_product =
  (id, data, token, success, status) => (dispatch) => {
    axios
      .post(
        `${process.env.REACT_APP_ADMIN_BASE_URL}/edit-product/${id}/${status}`,
        data,
        {
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((res) => {
        toast.success(res.data?.message);
        dispatch({
          type: UPDATE_PRODUCT,
          payload: res.data?.data,
        });
        success();
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const create_category = (data, token) => (dispatch) => {
  axios
    .post(`${process.env.REACT_APP_ADMIN_BASE_URL}/create-category`, data, {
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      if (res.data?.success == true) {
        toast.success(res.data?.message);
        dispatch({ type: ADD_CATEGORY, payload: data });
      } else {
        toast.error(res.data?.message);
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const create_supplier = (data, token, success) => (dispatch) => {
  axios
    .post(`${process.env.REACT_APP_ADMIN_BASE_URL}/add-supplier`, data, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then((res) => {
      if (res.data?.success == true) {
        toast.success(res.data?.message);
        dispatch({
          type: ADD_SUPPLIER,
          payload: res.data?.data,
        });
        success();
      } else {
        toast.error(res.data?.message);
      }
    })
    .catch((err) => {
      toast.error(err.response?.data?.message[0]);
      success();
    });
};

export const create_customer = (data, token, success) => (dispatch) => {
  axios
    .post(`${process.env.REACT_APP_ADMIN_BASE_URL}/add-user`, data, {
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      if (res.data?.success == true) {
        toast.success(res.data?.message);
        dispatch({
          type: ADD_CUSTOMER,
          payload: res.data?.data,
        });
        success();
      } else {
        toast.error(res.data?.message);
      }
    })
    .catch((err) => {
      toast.error(err.response?.data?.message[0]);
      success();
    });
};

export const verify_customer = (id, token, success) => (dispatch) => {
  axios
    .post(
      `${process.env.REACT_APP_ADMIN_BASE_URL}/user-action/verify`,
      {
        id,
      },
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    )
    .then((res) => {
      if (res.data?.success == true) {
        toast.success(res.data?.message);
        dispatch({ type: DELETE_UNAPPROVED_CUSTOMER, payload: id });
        success();
      } else {
        toast.error(res.data?.message);
      }
    })
    .catch((err) => {
      toast.error(err.response?.data?.message[0]);
      success();
    });
};

export const get_categories = (token) => (dispatch) => {
  axios
    .get(`${process.env.REACT_APP_ADMIN_BASE_URL}/get-categories`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then((res) => {
      dispatch({ type: FETCH_CATEGORIES, payload: res.data });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const get_supplier = (id, status) => (dispatch) => {
  if (status === "approved") {
    dispatch({ type: FETCH_APPROVED_SUPPLIER, payload: id });
  } else {
    dispatch({ type: FETCH_UNAPPROVED_SUPPLIER, payload: id });
  }

  // axios     .get(`${process.env.REACT_APP_ADMIN_BASE_URL}/get-supplier/${id}`,
  // {     headers: {         'Authorization': 'Bearer ' + token     } })
  // .then(res => {         console.log(res);         dispatch({             type:
  // FETCH_SUPPLIER,             payload: res.data                 ?.data }) })
  // .catch(err => {         console.log(err);     })
};

export const get_settings = (token, success) => (dispatch) => {
  axios
    .get(`${process.env.REACT_APP_ADMIN_BASE_URL}/get-settings`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then((res) => {
      if (success) success();
      dispatch({
        type: FETCH_SETTINGS,
        payload: res.data?.data,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const export_products = (token, data, type, success) => (dispatch) => {
  axios
    .get(`${process.env.REACT_APP_ADMIN_BASE_URL}/export-products/${type}`, {
      responseType: "blob",
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then((response) => {
      const content = response.headers["content-type"];
      download(response.data, "products." + type, content);
      success();
    })
    .catch((err) => {
      console.log(err);
    });
};

export const update_supplier_profile =
  (id, data, status, token, success) => (dispatch) => {
    axios
      .post(
        `${process.env.REACT_APP_ADMIN_BASE_URL}/update-supplier-profile/${id}`,
        data,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        dispatch({
          type:
            status === "approved"
              ? UPDATE_SUPPLIER
              : UPDATE_UNAPPROVED_SUPPLIER,
          payload: res?.data?.data,
        });
        toast.success(res.data?.message);
        success();
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const update_supplier_licence =
  (id, data, status, token, success) => (dispatch) => {
    axios
      .post(
        `${process.env.REACT_APP_ADMIN_BASE_URL}/update-supplier-licence/${id}`,
        data,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        console.log(res);
        toast.success(res.data?.message);
        dispatch({
          type:
            status === "approved"
              ? UPDATE_SUPPLIER
              : UPDATE_UNAPPROVED_SUPPLIER,
          payload: res?.data?.data,
        });
        success();
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const update_supplier_password =
  (id, data, token, success) => (dispatch) => {
    axios
      .post(
        `${process.env.REACT_APP_ADMIN_BASE_URL}/update-supplier-password/${id}`,
        data,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        console.log(res);
        toast.success(res.data?.message);
        success();
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const update_next_of_kin =
  (id, data, status, token, success) => (dispatch) => {
    axios
      .post(
        `${process.env.REACT_APP_ADMIN_BASE_URL}/update-next-of-kin/${id}`,
        data,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        console.log(res);
        toast.success(res.data?.message);
        dispatch({
          type:
            status === "approved"
              ? UPDATE_SUPPLIER
              : UPDATE_UNAPPROVED_SUPPLIER,
          payload: res?.data?.data,
        });
        success();
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const update_customer_profile =
  (id, data, status, token, success) => (dispatch) => {
    axios
      .post(
        `${process.env.REACT_APP_ADMIN_BASE_URL}/update-customer-profile/${id}`,
        data,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        console.log(res);
        toast.success(res?.data.message);
        dispatch({
          type:
            status === "approved"
              ? UPDATE_CUSTOMER
              : UPDATE_UNAPPROVED_CUSTOMER,
          payload: res?.data?.data,
        });
        success();
      })
      .catch((err) => {
        toast.error(err.response?.data?.message[0]);
      });
  };

export const update_customer_licence =
  (id, data, updatedLicence, token) => (dispatch) => {
    axios
      .post(
        `${process.env.REACT_APP_ADMIN_BASE_URL}/update-customer-id/${id}`,
        data,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        console.log(res);
        toast.success(res?.data.message);
        dispatch({ type: UPDATE_CUSTOMER_LICENCE, payload: updatedLicence });
      })
      .catch((err) => {
        toast.error(err.response?.data?.message[0]);
      });
  };

export const update_customer_password =
  (id, data, token, success) => (dispatch) => {
    axios
      .post(
        `${process.env.REACT_APP_ADMIN_BASE_URL}/update-customer-password/${id}`,
        data,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        console.log(res);
        toast.success(res.data?.message);
        success();
      })
      .catch((err) => {
        toast.error(err.response?.data?.message[0]);
      });
  };

export const suspend_user = (id, token, success) => (dispatch) => {
  axios
    .post(
      `${process.env.REACT_APP_ADMIN_BASE_URL}/user-action/suspend`,
      {
        id,
      },
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    )
    .then((res) => {
      console.log(res);
      toast.success(res.data?.message);
      dispatch({
        type: UPDATE_MULTIPLE_CUSTOMERS,
        payload: res.data?.user,
      });
      success();
    })
    .catch((err) => {
      console.log(err);
    });
};

export const unsuspend_user = (id, token, success) => (dispatch) => {
  axios
    .post(
      `${process.env.REACT_APP_ADMIN_BASE_URL}/user-action/unsuspend`,
      {
        id,
      },
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    )
    .then((res) => {
      console.log(res.data.user[0]);
      toast.success(res.data?.message);
      dispatch({
        type: UPDATE_MULTIPLE_CUSTOMERS,
        payload: res.data?.user,
      });
      success();
    })
    .catch((err) => {
      console.log(err);
    });
};

export const suspend_supplier = (id, token, success) => (dispatch) => {
  const body = {
    id,
  };
  axios
    .post(
      `${process.env.REACT_APP_ADMIN_BASE_URL}/supplier-action/suspend`,
      body,
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    )
    .then((res) => {
      console.log(res);
      toast.success("Supplier has been suspended");
      dispatch({
        type: UPDATE_MULTIPLE_APPROVED_SUPPLIERS,
        payload: res.data?.user,
      });
      success();
    })
    .catch((err) => {
      console.log(err);
    });
};

export const unsuspend_supplier = (id, token, success) => (dispatch) => {
  axios
    .post(
      `${process.env.REACT_APP_ADMIN_BASE_URL}/supplier-action/unsuspend`,
      {
        id,
      },
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    )
    .then((res) => {
      console.log(res);
      toast.success(res.data?.message);
      dispatch({
        type: UPDATE_MULTIPLE_APPROVED_SUPPLIERS,
        payload: res.data?.user,
      });
      success();
    })
    .catch((err) => {
      console.log(err);
    });
};

export const activate_product = (id, token, success) => (dispatch) => {
  let body = {
    id,
  };
  axios
    .post(
      `${process.env.REACT_APP_ADMIN_BASE_URL}/product-action/activate`,
      body,
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    )
    .then((res) => {
      console.log(res);
      toast.success(res.data?.message);
      dispatch({
        type: UPDATE_PRODUCT,
        payload: res.data?.products,
      });
      // success();
    })
    .catch((err) => {
      console.log(err);
    });
};

export const deactivate_product = (id, token, success) => (dispatch) => {
  axios
    .post(
      `${process.env.REACT_APP_ADMIN_BASE_URL}/product-action/deactivate`,
      {
        id,
      },
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    )
    .then((res) => {
      console.log(res);
      toast.success(res.data?.message);
      dispatch({
        type: UPDATE_PRODUCT,
        payload: res.data?.products,
      });
      // success();
    })
    .catch((err) => {
      console.log(err);
    });
};

export const delete_product = (id, token, success) => (dispatch) => {
  axios
    .post(
      `${process.env.REACT_APP_ADMIN_BASE_URL}/product-action/delete`,
      {
        id,
      },
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    )
    .then((res) => {
      console.log(res);
      toast.success(res.data?.message);
      dispatch({ type: DELETE_PRODUCT, payload: id });
      success();
    })
    .catch((err) => {
      console.log(err);
    });
};

export const delete_supplier =
  (id, token, success, unapproved) => (dispatch) => {
    let body = {
      id,
    };
    axios
      .post(
        `${process.env.REACT_APP_ADMIN_BASE_URL}/supplier-action/delete`,
        body,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        console.log(res);
        toast.success(res.data?.message);
        if (unapproved) {
          dispatch({ type: DELETE_UNAPPROVED_SUPPLIER, payload: id });
        } else {
          dispatch({ type: DELETE_APPROVED_SUPPLIER, payload: id });
        }
        success();
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const delete_user = (id, token, success, unapproved) => (dispatch) => {
  axios
    .post(
      `${process.env.REACT_APP_ADMIN_BASE_URL}/user-action/delete`,
      {
        id,
      },
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    )
    .then((res) => {
      console.log(res);
      toast.success(res.data?.message);
      if (unapproved) {
        dispatch({ type: DELETE_UNAPPROVED_CUSTOMER, payload: id });
      } else {
        dispatch({ type: DELETE_APPROVED_CUSTOMER, payload: id });
      }
      success();
    })
    .catch((err) => {
      console.log(err);
    });
};

export const get_customer = (id, status, token) => (dispatch) => {
  if (status === "approved") {
    dispatch({ type: GET_CUSTOMER, payload: id });
  } else {
    dispatch({ type: GET_UNAPPROVED_CUSTOMER, payload: id });
  }

  // axios     .get(`${process.env.REACT_APP_ADMIN_BASE_URL}/get-user/${id}`, {
  // headers: {         'Authorization': 'Bearer ' + token     } }) .then(res => {
  //     console.log(res); }) .catch(err => {     console.log(err); })
};

export const approve_supplier = (id, token, success) => (dispatch) => {
  axios
    .post(
      `${process.env.REACT_APP_ADMIN_BASE_URL}/supplier-action/approve`,
      {
        id,
      },
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    )
    .then((res) => {
      console.log(res);
      toast.success(res.data?.message);
      dispatch({ type: DELETE_UNAPPROVED_SUPPLIER, payload: id });
      success();
    })
    .catch((err) => {
      console.log(err);
    });
};

export const restore_account =
  (id, token, success, type = "customer") =>
  (dispatch) => {
    axios
      .post(
        `${process.env.REACT_APP_ADMIN_BASE_URL}/restore-account`,
        {
          id,
          type,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        console.log(res);
        toast.success(res.data?.message);
        if (type == "supplier") {
          dispatch({ type: RESTORE_SUPPLIER_ACCOUNT, payload: id });
        } else {
          dispatch({ type: RESTORE_USER_ACCOUNT, payload: id });
        }

        success();
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const update_payment_status =
  (id, status, token, success) => (dispatch) => {
    axios
      .post(
        `${process.env.REACT_APP_ADMIN_BASE_URL}/update-order-payment-status/${id}/${status}`,
        null,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        console.log(id);
        toast.success(res.data?.message);
        dispatch({
          type: UPDATE_SUPPLIER_PAYMENTS,
          payload: { id: id, status: status },
        });
        success();
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const decline_supplier = (id, token, success) => (dispatch) => {
  axios
    .post(
      `${process.env.REACT_APP_ADMIN_BASE_URL}/supplier-action/decline`,
      {
        id,
      },
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    )
    .then((res) => {
      console.log(res);
      toast.success(res.data?.message);
      dispatch({ type: DELETE_UNAPPROVED_SUPPLIER, payload: id });
      success();
    })
    .catch((err) => {
      console.log(err);
    });
};

export const pause_suppliers_signup = (token, success) => (dispatch) => {
  axios
    .post(
      `${process.env.REACT_APP_ADMIN_BASE_URL}/supplier-setting/pause`,
      {},
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    )
    .then((res) => {
      success();
      toast.success(res.data?.data);
      dispatch({ type: PAUSE_SUPPLIER_SIGNUP });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const resume_suppliers_signup = (token, success) => (dispatch) => {
  axios
    .post(
      `${process.env.REACT_APP_ADMIN_BASE_URL}/supplier-setting/resume`,
      {},
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    )
    .then((res) => {
      success();
      toast.success(res.data?.data);
      dispatch({ type: RESUME_SUPPLIER_SIGNUP });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const pause_user_signup = (token, success) => (dispatch) => {
  axios
    .post(
      `${process.env.REACT_APP_ADMIN_BASE_URL}/user-setting/pause`,
      {},
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    )
    .then((res) => {
      success();
      toast.success(res.data?.data);
      dispatch({ type: PAUSE_USER_SIGNUP });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const resume_user_signup = (token, success) => (dispatch) => {
  axios
    .post(
      `${process.env.REACT_APP_ADMIN_BASE_URL}/user-setting/resume`,
      {},
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    )
    .then((res) => {
      success();
      toast.success(res.data?.data);
      dispatch({ type: RESUME_USER_SIGNUP });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const update_username = (token, username) => (dispatch) => {
  axios
    .post(
      `${process.env.REACT_APP_ADMIN_BASE_URL}/update-profile`,
      {
        username,
      },
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    )
    .then((res) => {
      console.log(res);
      toast.success(res.data?.message);
      dispatch({
        type: UPDATE_ADMIN_USERNAME,
        payload: res.data?.data,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const update_pass = (token, data) => (dispatch) => {
  axios
    .post(`${process.env.REACT_APP_ADMIN_BASE_URL}/update-password`, data, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then((res) => {
      console.log(res);
      toast.success(res.data?.message);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const update_bank_details = (data, token) => (dispatch) => {
  axios
    .post(`${process.env.REACT_APP_ADMIN_BASE_URL}/update-bank-details`, data, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then((res) => {
      console.log(res);
      toast.success(res.data?.message);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const get_orders =
  ({ token, status, success, params }) =>
  (dispatch) => {
    dispatch({ type: FETCH_ORDERS, payload: [] });
    let p = { page: 1 };
    let mparams = new URLSearchParams({ ...p, ...params }).toString();
    axios
      .get(
        `${process.env.REACT_APP_ADMIN_BASE_URL}/orders/${status}?${mparams}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        success();
        dispatch({ type: FETCH_ORDERS, payload: res.data.data });
        console.log(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const get_orders_by_supplier =
  ({ token, selected, success, params, filter, page = 1 }) =>
  (dispatch) => {
    dispatch({ type: FETCH_ORDERS_BY_SUPPLIER, payload: [] });
    let fltr = filter !== undefined ? "&filter=" + filter : "";
    let p = { page: 1 };
    let mparams = new URLSearchParams({ ...p, ...params }).toString();
    axios
      .get(
        `${process.env.REACT_APP_ADMIN_BASE_URL}/get-orders-by-supplier/${selected}?${mparams}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        success();
        dispatch({ type: FETCH_ORDERS_BY_SUPPLIER, payload: res.data.data });
        console.log(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
};

export const get_supplier_payments =
  ({ token, selected, success, params, filter, page = 1 }) =>
  (dispatch) => {
    dispatch({ type: FETCH_SUPPLIER_PAYMENTS, payload: [] });
    let p = { page: 1 };
    let mparams = new URLSearchParams({ ...p, ...params }).toString();
    axios
      .get(
        `${process.env.REACT_APP_ADMIN_BASE_URL}/get-payments-by-supplier/${selected}?${mparams}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        success();
        dispatch({ type: FETCH_SUPPLIER_PAYMENTS, payload: res.data.data });
        console.log(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
};

export const get_orders_by_customer =
  ({ token, selected, success, params, filter, page = 1 }) =>
  (dispatch) => {
    dispatch({ type: FETCH_ORDERS, payload: [] });
    let fltr = filter !== undefined ? "&filter=" + filter : "";
    let p = { page: 1 };
    let mparams = new URLSearchParams({ ...p, ...params }).toString();
    axios
      .get(
        `${process.env.REACT_APP_ADMIN_BASE_URL}/get-orders-by-customer/${selected}?${mparams}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        success();
        dispatch({ type: FETCH_ORDERS, payload: res.data.data });
        console.log(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
};

export const get_customer_payments =
  ({ token, selected, success, params, filter, page = 1 }) =>
  (dispatch) => {
    dispatch({ type: FETCH_SUPPLIER_PAYMENTS, payload: [] });
    let p = { page: 1 };
    let mparams = new URLSearchParams({ ...p, ...params }).toString();
    axios
      .get(
        `${process.env.REACT_APP_ADMIN_BASE_URL}/get-payments-by-customer/${selected}?${mparams}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        success();
        dispatch({ type: FETCH_SUPPLIER_PAYMENTS, payload: res.data.data });
        console.log(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
};

export const get_supplier_products =
  ({ token, selected, success, params, filter, page = 1 }) =>
  (dispatch) => {
    dispatch({ type: FETCH_SUPPLIER_PRODUCTS, payload: [] });
    let p = { page: 1 };
    let mparams = new URLSearchParams({ ...p, ...params }).toString();
    axios
      .get(
        `${process.env.REACT_APP_ADMIN_BASE_URL}/get-products-by-supplier/${selected}?${mparams}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        success();
        dispatch({ type: FETCH_SUPPLIER_PRODUCTS, payload: res.data.data });
        console.log(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  

export const get_supplier_reports = (token, selected) => (dispatch) => {
  dispatch({ type: FETCH_SUPPLIER_REPORTS, payload: [] });
  axios
    .get(
      `${process.env.REACT_APP_ADMIN_BASE_URL}/get-reports-by-supplier/${selected}`,
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    )
    .then((res) => {
      dispatch({ type: FETCH_SUPPLIER_REPORTS, payload: res.data.data });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const get_order = (id, token, success) => (dispatch) => {
  axios
    .get(`${process.env.REACT_APP_ADMIN_BASE_URL}/order-details/${id}`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then((res) => {
      success;
      dispatch({ type: FETCH_ORDER, payload: res.data.data });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const fetch_transactions =
  ({ token, type, success, params }) =>
  (dispatch) => {
    let p = { page: 1 };
    let mparams = new URLSearchParams({ ...p, ...params }).toString();
    axios
      .get(
        `${process.env.REACT_APP_ADMIN_BASE_URL}/transactions/${type}?${mparams}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        success();
        dispatch({ type: FETCH_TRANSACTIONS, payload: res.data.data });
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const fetch_selectedSuppliers = (id, token, success) => (dispatch) => {
  axios
    .get(`${process.env.REACT_APP_ADMIN_BASE_URL}/selected-suppliers/${id}`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then((res) => {
      success;
      dispatch({ type: FETCH_SELECTED_SUPPLIERS, payload: res.data.data });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const allocate_order =
  (id, supplier_id, token, success) => (dispatch) => {
    axios
      .get(
        `${process.env.REACT_APP_ADMIN_BASE_URL}/allocate-order/${id}/${supplier_id}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        toast.success(res.data?.data);
        success();
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const refund = (id, token, success) => (dispatch) => {
  axios
    .post(
      `${process.env.REACT_APP_ADMIN_BASE_URL}/refund/${id}`,
      {},
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    )
    .then((res) => {
      dispatch({ type: REFUND, payload: res.data.data });
      // success();
      toast.success(res.data?.message);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const cancel_order = (id, token, success) => (dispatch) => {
  axios
    .post(
      `${process.env.REACT_APP_ADMIN_BASE_URL}/cancel-order/${id}`,
      {},
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    )
    .then((res) => {
      success();
      toast.success(res.data?.message);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const pause_suppliers_call_request = (token, success) => (dispatch) => {
  axios
    .post(
      `${process.env.REACT_APP_ADMIN_BASE_URL}/supplier-call-request-action/pause`,
      {},
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    )
    .then((res) => {
      success();
      toast.success(res.data?.message);
      dispatch({ type: PAUSE_SUPPLIER_CALL_REQUEST });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const resume_suppliers_call_request = (token, success) => (dispatch) => {
  axios
    .post(
      `${process.env.REACT_APP_ADMIN_BASE_URL}/supplier-call-request-action/resume`,
      {},
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    )
    .then((res) => {
      success();
      toast.success(res.data?.message);
      dispatch({ type: RESUME_SUPPLIER_CALL_REQUEST });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const pause_customer_call_request = (token, success) => (dispatch) => {
  axios
    .post(
      `${process.env.REACT_APP_ADMIN_BASE_URL}/user-call-request-action/pause`,
      {},
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    )
    .then((res) => {
      success();
      toast.success(res.data?.message);
      dispatch({ type: PAUSE_CUSTOMER_CALL_REQUEST });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const resume_customer_call_request = (token, success) => (dispatch) => {
  axios
    .post(
      `${process.env.REACT_APP_ADMIN_BASE_URL}/user-call-request-action/resume`,
      {},
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    )
    .then((res) => {
      success();
      toast.success(res.data?.message);
      dispatch({ type: RESUME_CUSTOMER_CALL_REQUEST });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const get_call_requests =
  (type, status, search = "--", date = "--", token, success) =>
  (dispatch) => {
    axios
      .get(
        `${
          process.env.REACT_APP_ADMIN_BASE_URL
        }/callback-request/${type}/${status}/${
          search == "" ? "--" : search
        }/${date}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        success();
        if (type === "supplier") {
          dispatch({
            type: CALL_SUPPLIER_REQUESTS,
            payload: res.data?.data,
          });
        } else {
          dispatch({
            type: CALL_USER_REQUESTS,
            payload: res.data?.data,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const update_call_request = (id, type, token, success) => (dispatch) => {
  axios
    .post(
      `${process.env.REACT_APP_ADMIN_BASE_URL}/update-call-request/${id}`,
      "",
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    )
    .then((res) => {
      console.log(res);
      success();
      toast.success(res.data?.message);

      if (type === "supplier") {
        dispatch({
          type: DELETE_CALL_SUPPLIER_REQUEST,
          payload: id,
        });
      } else {
        dispatch({
          type: DELETE_CALL_USER_REQUEST,
          payload: id,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const get_faqs = (type, token, success) => (dispatch) => {
  axios
    .get(`${process.env.REACT_APP_ADMIN_BASE_URL}/faqs/${type}`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then((res) => {
      success();
      if (type === "supplier") {
        dispatch({ type: FETCH_SUPPLIER_FAQ, payload: res.data.data });
      } else {
        dispatch({ type: FETCH_CUSTOMER_FAQ, payload: res.data.data });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const create_faq = (data, status, token, success) => (dispatch) => {
  let body = {
    ...data,
    status,
  };

  axios
    .post(`${process.env.REACT_APP_ADMIN_BASE_URL}/create-faq`, body, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then((res) => {
      success();
      toast.success(res.data?.message);
      if (body.type === "supplier") {
        dispatch({ type: CREATE_SUPPLIER_FAQ, payload: body });
      } else {
        dispatch({ type: CREATE_USER_FAQ, payload: body });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const get_faq = (id, token, success) => (dispatch) => {
  axios
    .get(`${process.env.REACT_APP_ADMIN_BASE_URL}/faq/${id}`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then((res) => {
      success(res.data.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const update_faq = (id, data, token, success) => (dispatch) => {
  let body = {
    question: data.question,
    answer: data.answer,
  };
  axios
    .post(`${process.env.REACT_APP_ADMIN_BASE_URL}/update-faq/${id}`, body, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then((res) => {
      success();
      toast.success(res.data?.message);
      if (data.type === "supplier") {
        dispatch({ type: UPDATE_SUPPLIER_FAQ, payload: data });
      } else {
        dispatch({ type: UPDATE_USER_FAQ, payload: data });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const delete_faq = (id, type, token, success) => (dispatch) => {
  axios
    .get(`${process.env.REACT_APP_ADMIN_BASE_URL}/delete-faq/${id}`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then((res) => {
      success();
      toast.success(res.data?.message);
      if (type === "supplier") {
        dispatch({ type: DELETE_SUPPLIER_FAQ, payload: id });
      } else {
        dispatch({ type: DELETE_USER_FAQ, payload: id });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};
